<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <button :class="b()" @click="handleRow">
    <div :class="b('date')">
      <strong>{{ displayedDateParts.date }}</strong>
      <span>{{ displayedDateParts.time }}</span>
    </div>

    <div :class="b('type', { deposit: isDeposit, withdrawal: !isDeposit })">
      <span :class="b('type-icon')" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path
            :d="isDeposit ? 'M12 5v13m-5-5 5 5 5-5' : 'M12 19V6m-5 5 5-5 5 5'"
          />
        </svg>
      </span>
      <span>{{ displayedApplicationType }}</span>
    </div>

    <p :class="b('amount', { deposit: isDeposit, withdrawal: !isDeposit })">
      {{ displayedSignedAmount }}
    </p>

    <div :class="b('currency')">
      <span
        :class="
          b('currency-icon', { code: displayedCurrencyCode.toLowerCase() })
        "
      >
        {{ displayedCurrencySymbol }}
      </span>
      <span>{{ displayedCurrencyCode }}</span>
    </div>

    <p :class="b('commission')">{{ displayedCommission }}</p>

    <div :class="b('status')">
      <span
        :class="b('status-pill', { tone: displayedStatusTone })"
        :title="$t(displayedStatus)"
      >
        <i></i>
        <span>{{ $t(displayedStatus) }}</span>
      </span>
    </div>

    <div :class="b('actions')">
      <button
        v-if="isConfirmShow"
        :class="b('confirm')"
        @click.stop="handleConfirm"
      >
        {{ $t("Подтвердить") }}
      </button>

      <button
        v-if="isRemoveShow"
        :class="b('remove')"
        :aria-label="$t('Удалить')"
        @click.stop="handleRemove"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 7h12m-8 4v5m4-5v5M9 7l1-2h4l1 2m-8 0 1 13h8l1-13" />
        </svg>
      </button>
    </div>
  </button>
</template>
